<div id="academy-courses" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text" fxLayout="row">
            <mat-icon class="ml-20 s-40">storage</mat-icon>
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                {{'NOTIFICACION_PRODUCT.TITLE_HISTO_PROD'| translate}}
            </h1>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">
            <div >

                <ng-container *ngIf="cargando">
                  <div  fxLayout="column" fxLayoutAlign="center center" >
                    <div fxLayout="column" fxLayoutAlign="center center" >
                      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                      <h2>{{'NOTIFICACION_PRODUCT.CARG_INFOR'| translate}}</h2>
                    </div>
                  </div>
                </ng-container>


                <ng-container *ngIf="!cargando">
<!--
                <form class="" id="busquedaForm"> <input type="text" name="" id="valor" ><button>BUSCAR</button>

                </form> -->

                <mat-sidenav-container class="tableside">
                  <mat-sidenav mode="side" [(opened)]="filtroAbierto" position="end">
                  <div class="" fxLayout="column" fxLayoutAlign="space-between center">
                    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                       <p></p>
                      <p>{{'NOTIFICACION_PRODUCT.TITLE_FILTER'| translate}}</p>
                      <button mat-raised-button color="primary" (click)="resetInformacion()" class="btnreset">{{'NOTIFICACION_PRODUCT.DELETE_FILTER'| translate}}</button>
                    </div>
                    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                      <p>{{'NOTIFICACION_PRODUCT.FILTER_1'| translate}} </p>
                      <mat-form-field appearance="outline">
                        <input matInput [matDatepicker]="picker" [(ngModel)]="fechaBuscar">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                   <div class="" fxLayout="row" fxLayoutAlign="center center">
                     <button mat-raised-button color="primary" (click)="filtrarInformacion()">{{'NOTIFICACION_PRODUCT.BUSCAR_FILTER'| translate}} <mat-icon>search</mat-icon></button>
                   </div>
                  </mat-sidenav>


                  <mat-sidenav-content>
                      <table>
                        <thead>
                          <tr>
                            <th colspan="2" style="color:white; background-color:#0B5394" >
                              <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                                <p>{{'NOTIFICACION_PRODUCT.TH_TITTLE'| translate}}</p>
                                <button mat-raised-button color="primary" (click)="filtroAbierto=!filtroAbierto">{{'NOTIFICACION_PRODUCT.BTN_FILTER_HISTO'| translate}}<mat-icon>filter_list</mat-icon></button>
                              </div> </th>
                          </tr>
                          <tr>
                            <td class="border" style="weight:40%">{{'NOTIFICACION_PRODUCT.TD_USUARIO'| translate}}</td>
                            <td class="border" style="weight:60%">{{userData.user}}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngIf="conDatos">
                            <ng-container  *ngFor="let people of infoHistorial;let ar = index " >
                              <tr>
                                <td>{{people.fecha | date:'fullDate':'':idiomaActual}}</td>
                              </tr>
                              <ng-container *ngFor="let people1 of people.datos; let i = index ">
                                <ng-container *ngIf="people1.accionText!=undefined && people1.accionText!='accionText' && people1.accionText!='' ">
                                  <tr>
                                    <td colspan="2" class="border" align="center" [ngClass]="{'desactivado': !people1.mostrar, 'activado': people1.mostrar }">
                                      <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class=""  fxLayout="row" fxLayoutAlign="center center" >
                                          {{people1.createdAt | date:'shortTime':'':idiomaActual}} <mat-icon style="color:#3DA2C6">settings</mat-icon>
                                        </div>
                                        <div class="" fxLayout="row" fxLayoutAlign="center center" >
                                          {{'NOTIFICACION_PRODUCT.TIPO_MENSAJE_MOSTRAR.'+people1.accionText | translate}} <button mat-icon-button aria-label="Example icon button with a vertical three dot icon"  (click)="mostrarTr(ar,i)"><mat-icon *ngIf="!people1.mostrar" >expand_more</mat-icon> <mat-icon *ngIf="people1.mostrar" >expand_less</mat-icon></button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </ng-container >
                                <ng-container *ngIf="people1.mostrar">
                                  <tr rowspan="4">
                                    <td class="border tdcasilla"  colspan="2" >
                                      <div class=""  fxLayout="row" fxLayoutAlign="start center" style="margin-left:20px" >
                                        <mat-icon>person</mat-icon>
                                        <div class="" fxLayout="column" fxLayoutAlign="start stretch" >
                                          <p style="margin:0px">{{people1.user.user}}</p>
                                          <p style="margin:0px">{{people1.createdAt | date:'long':'':idiomaActual}}</p>
                                        </div>

                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="border tdcasilla">{{'NOTIFICACION_PRODUCT.TD_FECHA_PRODU'| translate}}</td>
                                    <td class="border">{{people1.fechaProducto}}</td>
                                  </tr>
                                  <tr>
                                    <td class="border tdcasilla">{{'NOTIFICACION_PRODUCT.TD_TIPO_PRODU'| translate}}</td>
                                    <td class="border">{{'NOTIFICACION_PRODUCT.PRODUCTOS_ID.'+people1.tipoProducto | translate}}</td>
                                  </tr>
                                  <!-- <tr>
                                    <td class="border tdcasilla">Producto Id</td>
                                    <td class="border">{{people1.productoId}}</td>
                                  </tr> -->
                                  <tr *ngIf="people1.userAdministrator!=''">
                                    <td class="border tdcasilla">{{'NOTIFICACION_PRODUCT.TD_TIPO_USU_ADMI'| translate}}</td>
                                    <td class="border">{{people1.userAdministrator}}</td>
                                  </tr>
                                </ng-container>

                              </ng-container>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="!conDatos">
                            <div fxLayout="column" fxLayoutAlign="center stretch" >
                              <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="center center">
                                <h2>{{'NOTIFICACION_PRODUCT.WARNING_NO_DATOS'| translate}}</h2>
                                <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                              </div>
                            </div>
                          </ng-container>
                        </tbody>
                      </table>
                  </mat-sidenav-content>
                </mat-sidenav-container>

                </ng-container>

            </div>
        </div>
